import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import * as api from "../../api/index";
import { jwtDecode } from "jwt-decode";

const Viewshoprider = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;
  const userId = decoded?._id || decoded?.id || null;

  const [shop, setShop] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Pagination
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 20;

  const fetchShop = async (currentPage) => {
    try {
      setLoading(true);
      setError("");
      const res = await api.Viewshop(id, currentPage, limit);
      if (res?.data) {
        setShop(res.data);
        setTotalPages(res.data.pagination?.totalPages || 1);
      } else {
        setShop(null);
        setTotalPages(1);
      }
    } catch (err) {
      setError("Failed to load shop details.");
      setShop(null);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShop(page);
  }, [id, page]);

  // Handle phone reveal
  const handleViewPhone = () => {
    if (!token) {
      navigate("/auth");
      return;
    }

    // Show phone in an alert or call directly
    if (shop?.phone) {
      window.location.href = `tel:${shop.phone}`;
    }
  };

  if (loading)
    return (
      <p className="text-center mt-6 text-gray-500">
        Loading details...
      </p>
    );

  if (error) return <p className="text-center mt-6 text-red-500">{error}</p>;
  if (!shop)
    return <p className="text-center mt-6 text-gray-500"> User not found</p>;

  return (
    <div className="min-h-screen bg-gray-50 p-6 space-y-6">
      {/* Back Button */}
      <div className="w-full mb-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-700 hover:text-gray-900"
        >
          <IoMdArrowBack size={24} />
          <span className="ml-1">Back</span>
        </button>
      </div>

      {/* Shop Details */}
      <div className="bg-white rounded-2xl shadow p-6">
        <div className="flex items-center md:flex-col md:items-start space-x-4 md:space-x-0">
          <img
            src={`${shop.profileImage}`}
            alt={shop.Name}
            className="w-24 h-24 rounded-xl object-cover border border-gray-300"
          />

          <div className="mt-2">
            <h1 className="text-2xl font-bold">{shop.Name}</h1>
            <p className="text-gray-600 mt-1">{shop.bio}</p>
            <p className="text-sm text-gray-500 mt-2">
              {shop.lga} • {shop.address}
            </p>

            {/* Call Seller Button */}
            <div className="mt-4">
              <button
                onClick={handleViewPhone}
                className="bg-green-600 text-white px-6 py-2 rounded-xl shadow hover:bg-green-700 transition flex items-center space-x-2"
              >
                <span>📞</span>
                <span>
                  {token ? `Call Seller (${shop.phone || "N/A"})` : "View Phone Number"}
                </span>
              </button>
            </div>
          </div>
        </div>
  <div className="mt-2">
  
    <button
      onClick={() => {
        if (!token) {
          navigate("/auth"); // redirect to Sign In
        } else {
        
        navigate("/create-order", {
          state: {
            sellerId: id || "" ,
          },
        })
      
        }
      }}
      className={`px-6 py-2 rounded-xl shadow text-white transition ${
        token
          ? "bg-teal-600 hover:bg-teal-700"
          : "bg-gray-400 cursor-not-allowed"
      }`}
    >
      Create Order
    </button>
  </div>
     
      </div>

      {/* Gallery */}
      {shop.shopImages?.length > 0 && (
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-lg font-semibold mb-3">Gallery</h2>
          <div className="grid grid-cols-3 gap-4 sm:grid-cols-1">
            {shop.shopImages.map((img, index) => (
              <img
                key={index}
                src={`${img}`}
                alt={`Shop Image ${index + 1}`}
                className="w-full h-40 object-cover rounded-xl"
              />
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center items-center mt-4 gap-3">
            <button
              disabled={page === 1}
              onClick={() => setPage((p) => p - 1)}
              className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-50"
            >
              Prev
            </button>
            <span>
              Page {page} of {totalPages}
            </span>
            <button
              disabled={page === totalPages}
              onClick={() => setPage((p) => p + 1)}
              className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Viewshoprider;
